// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchBar_searchContainer__1nk0D","search":"SearchBar_search__IqOhu"};